//for theme
import {
  alpha,
  createTheme,
  PaletteColor,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material";
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    farm: true;
    farm01: true;
    farm02: true;
    risinblack: true;
    mint: true;
    agriwhite: true;
    fileuploadbtn: true;
    agritinytag: true;
    agrimodal: true;
    agricolors: true;
    agriform: true;
    fieldmodal: true;
    mapheight: true;
    AgentWebHeight: true;
  }
}
declare module "@mui/material/styles" {
  interface Palette {
    farm: PaletteColor;
    farm01: PaletteColor;
    farm02: PaletteColor;
    risinblack: PaletteColor;
    mint: PaletteColor;
    agriwhite: PaletteColor;
    fileuploadbtn: PaletteColor;
    agritinytag: PaletteColor;
    sidebar: PaletteColor;
    agrimodal?: {
      header?: string;
      footer?: string;
    };
    agricolors?: {
      //default color
      success?: string;
      warning?: string;
      info?: string;
      error?: string;
      danger?: string;
      drawerheader?: string;
      drawerfooter?: string;
      whitebg?: string;
      whitetext?: string;
    };
    agriform?: {
      //field colors
      fieldheader?: string;
      header?: string;
      footer?: string;
      fieldwrapper?: string;
      frombtnborder?: string;
      fieldcontrolsdiv?: string;
      fieldcontrolsborder?: string;
      tinyformlistbg?: string;
      mobilepreviewbg?: string;
      webpreviewbg?: string;
      mobilebordercolor?: string;
    };
    fieldmodal?: {
      xs?: string;
      sm?: string;
      md?: string;
      lg?: string;
      xl?: string;
    };
    mapheight?: {
      fielddetails?: string;
      dahboardmap?: string;
      dahboardmapright?: string;
      fieldMap?: string;
    };
    agrigradient: {
      headerbggrd: string;
      siderbarheadgrd: string;
      textcolor: string;
    };
    AgentWebHeight?: {
      farmerstepper?: string;
      fieldstepper?: string;
      farmerdetailleft?: string;
      farmerdetailleftnew?: string;
      farmerdetailright?: string;
      farmerdetailrightnew?: string;
    };
  }

  interface PaletteOptions {
    farm?: PaletteColorOptions;
    farm01?: PaletteColorOptions;
    farm02?: PaletteColorOptions;
    risinblack?: PaletteColorOptions;
    mint?: PaletteColorOptions;
    agriwhite?: PaletteColorOptions;
    fileuploadbtn?: PaletteColorOptions;
    agritinytag?: PaletteColorOptions;
    sidebar?: PaletteColorOptions;
    agrimodal?: {
      header?: string;
      footer?: string;
    };
    agricolors?: {
      //default color
      success?: string;
      warning?: string;
      info?: string;
      error?: string;
      danger?: string;
      drawerheader?: string;
      drawerfooter?: string;
      whitebg?: string;
      whitetext?: string;
    };
    agriform?: {
      //field colors
      fieldheader?: string;
      header?: string;
      footer?: string;
      fieldwrapper?: string;
      frombtnborder?: string;
      fieldcontrolsdiv?: string;
      fieldcontrolsborder?: string;
      tinyformlistbg?: string;
      mobilepreviewbg?: string;
      webpreviewbg?: string;
      mobilebordercolor?: string;
    };
    fieldmodal?: {
      xs?: string;
      sm?: string;
      md?: string;
      lg?: string;
      xl?: string;
    };
    mapheight?: {
      fielddetails?: string;
      dahboardmap?: string;
      dahboardmapright?: string;
      fieldMap?: string;
    };
    agrigradient?: {
      headerbggrd?: string;
      siderbarheadgrd?: string;
      textcolor?: string;
    };
    AgentWebHeight?: {
      farmerstepper?: string;
      fieldstepper?: string;
      farmerdetailleft?: string;
      farmerdetailleftnew?: string;
      farmerdetailright?: string;
      farmerdetailrightnew?: string;
    };
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: "#004225",
      light: "#34603A",
      dark: "#157B2C",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#157B2C",
      light: "#34603A",
      dark: "#004225",
      contrastText: "#ffffff",
    },
    farm: {
      main: "#004225",
      light: "#34603A",
      dark: "#157B2C",
      contrastText: "#ffffff",
    },
    farm01: {
      main: "#3D6F44",
      light: "#58A062",
      dark: "#2A5130",
      contrastText: "#ffffff",
    },
    farm02: {
      main: "#2D5F33",
      light: "#3C8245",
      dark: "#1E4823",
      contrastText: "#ffffff",
    },
    risinblack: {
      main: "#272932",
      light: "#474B5C",
      dark: "#1A1C24",
      contrastText: "#ffffff",
    },
    mint: {
      main: "#96FFA4",
      light: "#C3FFCB",
      dark: "#41DB56",
      contrastText: "#416746",
    },
    agriwhite: {
      main: "#545454",
      light: "#EFEFEF",
      dark: "#767676", //hover state
      contrastText: "#fff",
    },
    fileuploadbtn: {
      main: "#EFEFEF",
      light: "#64B770",
      dark: "#DADADA",
      contrastText: "#272932",
    },
    agritinytag: {
      main: "#E1F0FF",
      light: "#272932",
      dark: "#D1E5F9", //hover state
      contrastText: "#272932",
    },
    sidebar: {
      main: "#004225",
      light: "#ff8a50",
      dark: "#c41c00",
      contrastText: "#ffffff",
    },
    agrimodal: {
      header: "#f2f2f2",
      footer: "#f2f2f2",
    },
    agricolors: {
      // default colors
      success: "#27B63D",
      warning: "#ffc107",
      info: "#0dcaf0",
      error: "#d32f2f",
      danger: "#d32f2f",
      drawerheader: "#f2f2f2",
      drawerfooter: "#f2f2f2",
      whitebg: "#ffffff",
      whitetext: "#ffffff",
    },
    agriform: {
      //field colors
      fieldheader: "#F4F9FF",
      header: "#f2f2f2",
      footer: "#f2f2f2",
      // fieldwrapper: "#f5f7f8",
      fieldwrapper: "#f5f7f8",
      frombtnborder: "#ffffff",
      fieldcontrolsdiv: "#ffffff",
      fieldcontrolsborder: "#dddddd",
      tinyformlistbg: "#d9ebdc",
      mobilepreviewbg: "#DBE5DC",
      webpreviewbg: "#f2f2f2",
      mobilebordercolor: "#000000",
    },
    fieldmodal: {
      xs: "300px",
      sm: "550px",
      md: "700px",
      lg: "900px",
      xl: "1100px",
    },
    mapheight: {
      fielddetails: "calc(100vh - 295px)",
      dahboardmap: "calc(100vh - 142px)",
      dahboardmapright: "calc(100vh - 207px)",
      fieldMap: "calc(100vh - 400px)",
    },
    agrigradient: {
      headerbggrd: "linear-gradient(45deg, #157B2C 30%, #002615 90%)",
      siderbarheadgrd:
        "linear-gradient(0deg, rgba(0,66,37,1) 0%, rgba(39,41,50,1) 100%);",
      textcolor: "#ffffff",
    },
    AgentWebHeight: {
      fieldstepper: "calc(100vh - 360px)",
      farmerstepper: "calc(100vh - 380px)",
      farmerdetailleft: "calc(100vh - 485px)",
      farmerdetailleftnew: "calc(100vh - 545px)",
      farmerdetailright: "calc(100vh - 380px)",
      farmerdetailrightnew: "calc(100vh - 440px)",
    },
  },

  // Set the default font family
  typography: {
    fontFamily: "Figtree, sans-serif",
  },
  //Override font family of MUI component
  components: {
    MuiCssBaseline: {
      styleOverrides: `
            @font-face {
                font-family: 'Figtree';
                font-style: normal;
                font-weight: 400;
                src: local('Figtree'), url('https://fonts.gstatic.com/s/figtree/v1/filename.woff2') format('woff2');
            }
        `,
    },

    // Set the default font weight for button
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          textTransform: "none",
          //button border opacity color for Risinblack
          "&.MuiButton-outlinedRisinblack": {
            borderColor: alpha("#272932", 1),
            "&:hover": {
              borderColor: alpha("#272932", 0.7),
            },
          },
        },
      },
    },
  },
});
function rgba(arg0: string, arg1: number) {
  throw new Error("Function not implemented.");
}
